import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { EddEmbeddedFields } from '../../embedded/fields.types';
import { useIntendedUseLogic } from './hooks/useIntendedUseLogic';
import { IntendedUseForm } from './IntendedUseForm';

export const EddIntendedUse = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading, optionsList } = useIntendedUseLogic();

  const reactiveOption = formMethods.watch(EddEmbeddedFields.EDD_INTENDED_USE);

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.intendedUse.title')}
        text={t('organic.intendedUse.subtitle')}
        textCustomStyle='mt-[16px] text-text-main-primary text-[16px] whitespace-pre-line'
        headingContainerCustomStyle='!mb-[16px]'>
        <IntendedUseForm reactiveOption={reactiveOption} optionsList={optionsList} />
      </StepPageWrapper>
    </FormProvider>
  );
};
